import React, { useState, useEffect } from "react";
import { Container, Box, Grid } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import WeatherWidget from "../../components/WeatherWidget";
import QuickLinks from "../../components/QuickLinks";
import NewsSection from "../../components/AlertsUpdates";
import getQuickLinks from "../../Data/iconsData";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { useTranslation } from "react-i18next";
import api from "../../globals/axios";

export default function FPOHomepage() {
  const quickLinksData = getQuickLinks("fpo");
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState([]);
  const [fpoFarmerStats, setFpoFarmerStats] = useState({});

  const fetchAlertUpdates = async () => {
    try {
      const response = await api.get("/common/alert-updates/");
      setAlerts(response.data);
    } catch (error) {
      console.log("Error Fetching Tutorials list:", error);
    }
  };

  const fetchFPOFarmerStats = async () => {
    try {
      const response = await api.get("/fpo/fpo-stats/farmer_stats/");
      setFpoFarmerStats(response.data);
    } catch (error) {
      console.log("Error Fetching FPO Farmer Stats :", error);
    }
  };

  useEffect(() => {
    fetchAlertUpdates();
    fetchFPOFarmerStats();
  }, []);

  return (
    <div>
      <CustomAppBar />

      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <WeatherWidget />
        <Box sx={{ marginTop: "20px" }}>
          <Grid container spacing={0.5}>
            <Grid item xs={6}>
              <CustomDashboardCard
                title={t("TOTAL FARMERS")}
                data={
                  fpoFarmerStats.total_farmers
                    ? fpoFarmerStats.total_farmers
                    : 0
                }
              />
            </Grid>
            <Grid item xs={6}>
              <CustomDashboardCard
                title={t("COVERAGE FIELD")}
                data={fpoFarmerStats.total_area ? fpoFarmerStats.total_area : 0}
                unit={t("acres")}
              />
            </Grid>
          </Grid>
        </Box>
        <QuickLinks data={quickLinksData} />
      </Container>

      <Container maxWidth="xs" sx={{ marginBottom: "60px", padding: "0px" }}>
        <NewsSection images={alerts} />
      </Container>
    </div>
  );
}
